import axios from 'axios';
import {backendHost} from '../../config';

export const getPromo = (params) => {
    return axios.get(`${backendHost}/api/partners/admin/promos`, {params});
};